export const contentTableConfig = {
  title: '近30天累计听课大于10天的未成交客户企业业务员信息',
  propList: [
    {prop: 'unionid', label: '客户unionid', minWidth: '80'},
    {prop: 'custNickName', label: '客户昵称', minWidth: '80'},
    {prop: 'custUserId', label: '客户ID', minWidth: '80'},
    {prop: 'corPid', label: '主体ID', minWidth: '80'},
    {prop: 'corName', label: '主体名称', minWidth: '120'},
    {prop: 'empUserId', label: '业务员ID', minWidth: '80'},
    {prop: 'usedBy', label: '业务员姓名', minWidth: '80'},
    {prop: 'sysDate', label: '系统记录日期', minWidth: '80',slotName: 'sysDate'},
  ],
  showIndexColumn: false,
  showSelectColumn: false
}
